const app = {
  namespaced: true,
  state: {
    isLoading: false,
  },
  mutations: {
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
  },
  getters: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    balanceFormat: () => (num) => {
      if (typeof num === "string") {
        num = Number(num);
      }

      // Ensure `num` is a valid number
      if (typeof num !== "number" || isNaN(num)) {
        throw new TypeError(
          "Input must be a valid number or a string that can be converted to a number"
        );
      }

      // Special case for very small numbers (less than 0.0001)
      if (Math.abs(num) < 0.0001) {
        return "0"; // Return '0' for values less than 0.0001
      }

      // For numbers between 0 and 1 (but greater than or equal to 0.0001)
      if (Math.abs(num) < 1) {
        // Round to 4 decimal places and remove trailing zeros
        return num.toFixed(4).replace(/\.?0+$/, "");
      }

      // For numbers greater than or equal to 1
      return num.toLocaleString("en-US", {
        maximumFractionDigits: 3, // Round to 3 decimals
        minimumFractionDigits: 0, // Remove trailing zeros
      });

      // For numbers greater than or equal to 1
      // return num.toFixed(3).replace(/\.?0+$/, ""); // Round to 3 decimals and remove trailing zeros
    },
  },
};

export default app;
